import { RQStatus, SatDikDetail } from '@/apis/types'

import { ContentRowLoader } from './ContentLoader'
import { EmptyStateSatpen } from './EmptyStateSatpen'

export const TabPanelLoader = ({
  rows = 5,
  status,
  masterData,
  Panel,
}: {
  rows?: number
  status: RQStatus
  masterData?: SatDikDetail
  Panel: ({ data }: { data?: SatDikDetail }) => JSX.Element
}) => {
  return (
    <>
      {status === 'pending' ? (
        <ContentRowLoader rows={rows} />
      ) : (
        <>
          {status === 'error' || masterData?.nama === '' ? (
            <EmptyStateSatpen />
          ) : (
            <Panel data={masterData} />
          )}
        </>
      )}
    </>
  )
}
